import React from 'react'
import { FormProvider, useForm, useFormContext } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { mapSchema } from './schema'

export const MapFormProvider = ({ children }) => {
  const methods = useForm({
    resolver: yupResolver(mapSchema),
  })

  return <FormProvider {...methods}>{children}</FormProvider>
}

export const useMapFormContext = () => useFormContext()
